(function () {

    // size system preference memory (bra/panty toggle choice, remembered across visits)
    // used by assets/sus-product-variant-selection.js (pds) and assets/snippet-sus-facets.js (facets)
    // bra/panty share std/sus in sync and desync wfor the duration of int selection
    
    try {
        const SIZE_PREF_STORAGE_KEY = 'sus_size_system_pref';
        
        // max time declared also in snipets/sus-product-variant-selection.liquid
        const SIZE_PREF_MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // max timestamp for erasion: 90 days

        window.getSizeSystemPref = function (sType) {
            try {
                const oStored = JSON.parse(localStorage.getItem(SIZE_PREF_STORAGE_KEY) || '{}');
                if (oStored.ts && Date.now() - oStored.ts > SIZE_PREF_MAX_AGE_MS) {
                    localStorage.removeItem(SIZE_PREF_STORAGE_KEY);
                    return null; // erase after SIZE_PREF_MAX_AGE_MS reached without interaction
                }
                if (sType === 'panty' && oStored.pantyInt) return 'int';
                return oStored.shared || null;
            } catch (oErr) {
                return null;
            }
        };
        window.setSizeSystemPref = function (sType, sValue) {
            try {
                const oStored = JSON.parse(localStorage.getItem(SIZE_PREF_STORAGE_KEY) || '{}');
                if (sType === 'panty' && sValue === 'int') {
                    oStored.pantyInt = true;
                } else {
                    oStored.shared = sValue;
                    oStored.pantyInt = false;
                }
                oStored.ts = Date.now();
                localStorage.setItem(SIZE_PREF_STORAGE_KEY, JSON.stringify(oStored));
            } catch (oErr) {
                console.warn("error storing size system preference", oErr);
            }
        };
    } catch (oErr) {
        console.warn("error initializing size system preference", oErr);
    }

    //-- basic toggle box
    const oToggleBoxTrigger = document.querySelectorAll('[data-js-toggle-next-trigger]');
    if (oToggleBoxTrigger.length > 0) {
        oToggleBoxTrigger.forEach(elem => {
            elem.addEventListener('click', function () {
                elem.parentElement.nextElementSibling.classList.toggle('hidden');
            });
        });
    }

    const oToggleBoxClose = document.querySelectorAll('[data-js-toggle-next-close]');
    if (oToggleBoxClose.length > 0) {
        oToggleBoxClose.forEach(elem => {
            elem.addEventListener('click', function () {
                elem.closest('.toggle-next-container').classList.toggle('hidden');
            });
        });
    }

    //-- toggle text box (f.e. product details: more)
    let toggleTextBoxTrigger = document.querySelectorAll('[data-js-toggle-text-box-trigger]');
    if (toggleTextBoxTrigger.length > 0) {
        toggleTextBoxTrigger.forEach(elem => {
            elem.addEventListener('click', function () {
                elem.parentElement.classList.toggle('open');
            });
        });
    }

    //-- scroll to target (data-js-scroll-to='#id')
    let oScrollTrigger = document.querySelectorAll('[data-js-scroll-to]');
    if (oScrollTrigger.length > 0) {
        oScrollTrigger.forEach(elem => {
            elem.addEventListener('click', function (e) {
                e.preventDefault();
                let elemTargetValue = elem.getAttribute('data-js-scroll-to');
                let elemTarget = document.getElementById(elemTargetValue);
                if (elemTarget) {
                    elemTarget.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            });
        });
    }


    //-- breakpoint watcher (toggle footer nav for browsers without ::details-conten)
    let oFooterAccordion = document.querySelectorAll('footer .sus-footer-accordion details');
    let oFooterAccordionDefaultOpen = new Set();
    oFooterAccordion.forEach((item) => {
        if (item.hasAttribute('open')) {
            oFooterAccordionDefaultOpen.add(item);
        }
    });
    // matchMedia only fires on an actual breakpoint crossing — unlike a ResizeObserver on body,
    // it's unaffected by the body height change that opening/closing an accordion itself causes
    let mqFooterAccordionDesktop = window.matchMedia('(min-width: 990px)');
    function syncFooterAccordion(isDesktop) {
        oFooterAccordion.forEach((item) => {
            if (isDesktop) {
                item.setAttribute("open", '');
            } else if (!oFooterAccordionDefaultOpen.has(item)) {
                item.removeAttribute("open");
            }
        });
    }
    syncFooterAccordion(mqFooterAccordionDesktop.matches);
    mqFooterAccordionDesktop.addEventListener('change', (e) => syncFooterAccordion(e.matches));


    //-- simple accordion
    const accordionHeaders = document.querySelectorAll('.simple-accordion .accordion-header');
    if (accordionHeaders.length > 0) {
        accordionHeaders.forEach(header => {
            header.addEventListener('click', function () {
                const parent = this.parentElement;
                const isActive = parent.classList.contains('active');
                // document.querySelectorAll('.simple-accordion .accordion-item').forEach(item => { item.classList.remove('active'); }); // Close all sections first
                parent.classList.toggle('active');
            });
        });
    }

    //-- discount message
    try {

        let aMatch = document.cookie.match(/(^| )discount_code=([^;]+)/);
        let sDiscountCode = aMatch ? decodeURIComponent(aMatch[2]).toLowerCase() : null;

        if (sDiscountCode) {

            let sStorageKey = "discount_message_shown_" + sDiscountCode;
            let iStored = parseInt(localStorage.getItem(sStorageKey));
            
            if (!iStored || (Date.now() - iStored) > 30 * 60 * 1000) {
                (async () => {
                    try {

                        let sLang = window?.Shopify?.locale || 'de';
                        let sUrl = (sLang === 'en' ? "https://apps.sugarshape.de/en/check-discount/" : "https://apps.sugarshape.de/check-discount/") + encodeURIComponent(sDiscountCode);

                        const controller = new AbortController();
                        const timeout = setTimeout(() => controller.abort(), 2500);

                        let oResponse = await fetch(sUrl, {signal: controller.signal});
                        clearTimeout(timeout);

                        if (!oResponse.ok) return;

                        let oData = await oResponse.json();

                        if (oData.bSuccess === true) {
                            let sMsg = oData?.aDetails?.default_msg?.msg;
                            if (!sMsg) return;

                            let eMainContent = document.getElementById('MainContent');

                            if (eMainContent) {

                                if (!document.getElementById('sus-discount-style')) {
                                    let eStyle = document.createElement("style");
                                    eStyle.id = 'sus-discount-style';
                                    eStyle.textContent = `
                                        .sus-discount-msg {
                                            background-color: #d8efd0;
                                            animation: ss-discount-bg 4s ease-in-out;
                                        }

                                        @keyframes ss-discount-bg {
                                            50% {
                                                background-color: #b7ea98;
                                            }
                                        }
                                        .sus-customdiscount-msg {
                                            --ss-brand: var(--sus-color-brand);
                                            --ss-color: #c7e5bc;
                                            --ss-color-darker: hsl(from var(--ss-color) h s calc(l - 15));
                                            --ss-color-darkest: hsl(from var(--ss-color) h s calc(l - 30));
                                            --ss-color-lighter: hsl(from var(--ss-color) h s calc(l + 10));
                                            --ss-color-lightest: hsl(from var(--ss-color) h s calc(l + 20));
                                            display: flex;
                                            flex-direction: column;
                                            background: transparent;
                                            border-radius: var(--sus-border-radius);
                                            border: 0.2rem solid var(--ss-color);
                                            font-size: 1.4rem;
                                        }

                                        .sus-customdiscount-msg-wrapper {
                                            position: relative;
                                        }

                                        .sus-customdiscount-badge {
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            width: 100%;
                                            gap: 0.8rem;
                                            color: var(--sus-color-text);
                                            background: var(--ss-color);
                                            font-weight: 550;
                                            padding: 0.5rem;
                                            font-size: inherit;
                                        }
                                        @media (min-width: 600px) {
                                            .sus-customdiscount-badge br {
                                                display: none;
                                            }
                                        }

                                        .sus-customdiscount-check {
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            flex-shrink: 0;
                                            width: 20px;
                                            height: 20px;
                                            border-radius: 50%;
                                            background: var(--ss-color-lighter);
                                            color: var(--sus-color-text);
                                            font-size: 11px;
                                        }

                                        .sus-customdiscount-body-wrapper {
                                            display: flex;
                                            justify-content: center;
                                            align-items: center;
                                            flex-direction: column;
                                            gap: 1rem 2rem;
                                            padding: 1.2rem;
                                        }
                                        @media (min-width: 380px) {
                                            .sus-customdiscount-body-wrapper {
                                                flex-direction: row;
                                            }
                                        }
                                        @media (min-width: 720px) {
                                            .sus-customdiscount-body-wrapper {
                                                gap: 0.5rem 3rem;
                                            }
                                        }

                                        .sus-customdiscount-img {
                                            flex-shrink: 0;
                                            width: 70px;
                                            height: 70px;
                                            border-radius: 50%;
                                            border: 1px solid var(--ss-color);
                                            overflow: hidden;
                                            -o-object-fit: cover;
                                                object-fit: cover;
                                        }
                                        @media (min-width: 600px) {
                                            .sus-customdiscount-img {
                                                width: 84px;
                                                height: 84px;
                                            }
                                        }

                                        .sus-customdiscount-text-wrapper {
                                            display: flex;
                                            flex-flow: column wrap;
                                            justify-content: flex-start;
                                            gap: 0 4rem;
                                        }
                                        @media (min-width: 720px) {
                                            .sus-customdiscount-text-wrapper {
                                                flex-flow: row nowrap;
                                            }
                                        }

                                        .sus-customdiscount-text {
                                            text-align: center;
                                        }
                                        @media (min-width: 380px) {
                                            .sus-customdiscount-text {
                                                text-align: left;
                                            }
                                        }
                                        .sus-customdiscount-text em {
                                            padding-right: 0.2rem;
                                            font-style: normal;
                                            font-weight: 550;
                                            color: var(--ss-color-darker);
                                            word-break: break-all;
                                        }
                                        .sus-customdiscount-text strong {
                                            font-weight: 550;
                                        }

                                        .sus-customdiscount-subline {
                                            display: none;
                                        }
                                        @media (min-width: 720px) {
                                            .sus-customdiscount-subline {
                                                display: block;
                                            }
                                        }

                                        .sus-customdiscount-headline p, .sus-customdiscount-subline p {
                                            margin: 0;
                                            font-size: inherit;
                                        }

                                        .sus-customdiscount-link {
                                            border: none;
                                            display: table;
                                            margin: 0.3rem 0 0 auto;
                                            text-decoration: underline;
                                            white-space: nowrap;
                                            flex-shrink: 0;
                                        }
                                        @media (min-width: 720px) {
                                            .sus-customdiscount-link {
                                                align-self: center;
                                            }
                                        }
                                        @media (min-width: 1200px) {
                                            .sus-customdiscount-link {
                                                font-size: 1.5rem;
                                            }
                                        }
                                    `;
                                    document.head.appendChild(eStyle);
                                }

                                let oCustom = oData.aDetails.custom_msg;

                                //-- default message
                                if (!oCustom) {
                                    let eMsgContainer = document.createElement("div");
                                    eMsgContainer.classList.add('my-2', 'container', 'container-max-w');
                                    eMsgContainer.innerHTML = '<div class="p-4 sus-radius sus-discount-msg">' + sMsg + '</div>';
                                    eMainContent.prepend(eMsgContainer);
                                }

                                //-- custom message
                                if (oCustom) {

                                    let sLink = oCustom.link || '';
                                    if (sLink && !/^https?:\/\//i.test(sLink)) {
                                        sLink = (sLang === 'en' ? '/en/' : '/') + sLink.replace(/^\/+/, '');
                                    }

                                    let eCustomContainer = document.createElement("div");
                                    eCustomContainer.classList.add('my-2', 'container', 'container-max-w');
                                    eCustomContainer.innerHTML =
                                        '<div class="sus-customdiscount-msg">' +
                                        '<div class="sus-customdiscount-msg-wrapper">' +
                                        '<span class="sus-customdiscount-badge">' +
                                        '<span class="sus-customdiscount-check">' +
                                        '<svg class="icon icon-checkmark" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                        '<path d="M1 3.5L3 5.5L7 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>' +
                                        '</svg>' +
                                        '</span>' +
                                        '<span>' + (oCustom.badge || '') + '</span>' +
                                        '</span>' +
                                        '<div class="sus-customdiscount-body-wrapper">' +
                                        (oCustom.image ? '<img class="sus-customdiscount-img" src="' + oCustom.image + '" alt="" loading="lazy">' : '') +
                                        '<div class="sus-customdiscount-text-wrapper">' +
                                        '<div class="sus-customdiscount-text">' +
                                        '<div class="sus-customdiscount-headline">' + (oCustom.headline || '') + '</div>' +
                                        (oCustom.subline ? '<div class="sus-customdiscount-subline">' + oCustom.subline + '</div>' : '') +
                                        '</div>' +
                                        (oCustom.linklabel && sLink ? '<a class="sus-customdiscount-link" href="' + sLink + '" target="_blank">' + oCustom.linklabel + '</a>' : '') +
                                        '</div>' +
                                        '</div></div></div>';

                                    eMainContent.prepend(eCustomContainer);
                                }

                                localStorage.setItem(sStorageKey, Date.now().toString());
                            }
                        }
                    } catch (oErr) {
                        console.warn("error fetching discount", oErr);
                    }
                })();
            }
        }
    } catch (oErr) {
        console.warn("error checking discount", oErr);
    }
    

    //-- facebook click-id backup
    try {
        let oUrlParams = new URLSearchParams(window.location.search);

        if (oUrlParams.has("fbclid")) {

            let sFbclid = oUrlParams.get("fbclid");
            sFbclid = `fb.1.${Date.now()}.${sFbclid}`;

            let aHostParts = location.hostname.split('.');
            let sDomain = aHostParts.slice(-2).join('.');

            let iMaxAge = 60 * 60 * 24 * 90;

            document.cookie = `_fbcb=${sFbclid}; domain=${sDomain}; path=/; max-age=${iMaxAge}; SameSite=None; Secure`;
        }
    } catch (oErr) {
        console.warn("error catching fbcl", oErr);
    }
    

})()
